import type { ReviewsListResult } from 'lib/queries/reviews';
import React from 'react';
import { Paragraph, Wrap } from '@leafwell/components';
import Pagination from './pagination';
import Review from './review';
import { useWordPressContext } from 'contexts/wordpress-provider';

const ArchiveReviews: React.FC<ReviewsListResult> = ({
  reviews,
  pagination,
}) => {
  const { translations } = useWordPressContext();

  return (
    <Wrap className="sm:grid-cols-2 xl:grid-cols-3 sm:gap-x-16 xl:gap-y-16">
      {reviews ? (
        reviews.map(review => (
          <Review key={review.id} {...review} variant="full" />
        ))
      ) : (
        <Paragraph variant="medium" className="col-span-full">
          {translations['No results were found']}
        </Paragraph>
      )}
      <Pagination
        limit={pagination.limit}
        offset={pagination.offset}
        total={pagination.total}
        className={'col-span-full justify-self-center md:mt-6'}
      />
    </Wrap>
  );
};

export default ArchiveReviews;
